export default __webpack_public_path__ + "static/media/rings.c8dbf661.png";